import TextareaComponent from '../../../../commons/components/Forms/TextareaComponent';
import RadioboxComponent from '../../../../commons/components/Forms/RadioboxComponent';
import { useEffect, useRef, useState } from 'react';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../redux/actions/';
import SkeletonLoadingComponent from '../../../../commons/components/SkeletonLoading';
import { useVideoEmoji } from '../../../../commons/customHooks/Video';
import DialogComponent from '../../../../commons/components/Modal/DialogComponent';
type props = {
  publishedBtn: Boolean,
  videoDetail: Object,
  closePopupStatus: Function,
  showPublic: Boolean,
  isProcessing: Boolean,
  handleHeightPopup: Function,
  handleDialogConfirmUpdateStatus: Function
};

const VideoFormStatusComponent = ({
  publishedBtn,
  videoDetail,
  closePopupStatus,
  showPublic,
  isProcessing,
  handleHeightPopup,
  handleDialogConfirmUpdateStatus
}: props) => {
  const dispatch = useDispatch();

  const [videoEmoji, isProcessingEmoji] = useVideoEmoji(null);
  const [focusIpt, setFocusIpt] = useState(false);
  const messagesEndRef = useRef(null)

  const [dataVideoUpdate, setDataVideoUpdate] = useState({
    id: videoDetail?.video_message?.id || null,
    title: videoDetail?.video_message?.title || '',
    reaction_emoji: videoDetail?.video_message?.reaction_emoji ?? videoEmoji?.[0]?.id,
    reaction_content: videoDetail?.video_message?.reaction_content || '',
    published_at: new Date(),
    user_published_at: new Date(),
  });

  const [validate, setValidate] = useState(false);

  useEffect(() => {
    setDataVideoUpdate({
      id: videoDetail?.video_message?.id || null,
      title: videoDetail?.video_message?.title || '',
      reaction_emoji: videoDetail?.video_message?.reaction_emoji ?? videoEmoji?.[0]?.id,
      reaction_content: videoDetail?.video_message?.reaction_content || '',
      published_at: new Date(),
      user_published_at: new Date(),
    });
  }, [videoDetail]);

  const handleChangeEmoji = (e) => {
    console.log(e.target.value, 'e.target.value');
    setDataVideoUpdate({
      ...dataVideoUpdate,
      reaction_emoji: e.target.value,
    });
  };

  const handleChangeReactionContent = (e) => {
    let trimContent = e.target.value.trim();
    console.log(trimContent.length, 'vvvvvvvvvvv', trimContent.length > 10);
    setValidate(trimContent !== '' && trimContent.length > 10 ? false : true);
    setDataVideoUpdate({
      ...dataVideoUpdate,
      reaction_content: e.target.value.trim() !== '' ? e.target.value : '' ,
    });
  };

  const handleClick = () => {
    console.log(3423423423432);
    if (dataVideoUpdate.reaction_content == '') {
      setValidate(true)
    }
    console.log(dataVideoUpdate, 'dataVideoUpdate');
    if (!validate && dataVideoUpdate.reaction_content !== '') {
      dispatch(action.updateVideoRequest(dataVideoUpdate));
      handleDialogConfirmUpdateStatus(true);
    }
  };

  const chunk = (arr, size) => arr.reduce((acc, e, i) => (i % size ? acc[acc.length - 1].push(e) : acc.push([e]), acc), []); 

  const renderVideoEmoji = () => {
    if (videoEmoji && videoEmoji.length > 0) {
      return videoEmoji.map((item, idx) => {
          return (
            <div className="child" key={item.id}>
              <RadioboxComponent
                id={`js-emoji-${item.id}`}
                name={`reaction_emoji`}
                value={item.id}
                handleChange={handleChangeEmoji}
                checked={item.id == +dataVideoUpdate.reaction_emoji}
                disabled={!showPublic}
              />
              <div className="label">
                <img src={item.icon} /> <br />
                <small>{item.label}</small>
              </div>
            </div>
          )
        })
    }
  }


  const handleFocus = () => {
    handleHeightPopup('90vh');
  }

  const handleBlur = () => {
    handleHeightPopup('68vh');
  }

  console.log(122, publishedBtn);
  console.log(123, videoDetail);

  return (
    <>
    <div className={`row content ${focusIpt ? 'show-key-board' : ''}`} ref={messagesEndRef}>
      <div className="col-12 emoji">
        {renderVideoEmoji()}
      </div>

      {isProcessingEmoji ? (
        <>
          {/* <div className="col-12 d-flex justify-content-between mt-4">
            <SkeletonLoadingComponent count={1} height={30} />
          </div> */}
          <div className="col-12 mt-4 mb-5">
              <div className="textarea-component">
                <SkeletonLoadingComponent count={4} height={10} />
              </div>
            </div>
        </>
      ) : (
        <div className="col-12 mt-4 mb-3">
          <TextareaComponent
            isRequired={true}
            errorMsg={validate ? '10자이상의 후기를 남겨주세요.' : ''}
            placeHolder={`10자이상의 후기를 남겨주세요. \n스포키즈에 큰 힘이 됩니다!`}
            id={`js-reaction-content`}
            name={`reaction_content`}
            value={dataVideoUpdate.reaction_content || ''}
            handleChange={handleChangeReactionContent}
            disabled={!showPublic}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
          />
        </div>
      )}

      {!videoDetail?.video_message?.published_at && (
        <>
        <div className="col-12">
          <ButtonComponent
            label={`공개하기`}
            cssClass={`btn btn-block  album-video-detail-page__button-custom`}
            type="button"
            disabled={dataVideoUpdate.reaction_content == '' }
            handleClick={() => handleClick()}
          />
        </div>
        </>
      )}
    </div>
    

    </>
  );
};

VideoFormStatusComponent.defaultProps = {
  publishedBtn: false,
  showPublic: true
};

export default VideoFormStatusComponent;
